import presentationTemplates from './presentation-templates.module'
import contentSlideTemplates from './content-slide-templates.module'
import presentationReport from './presentation-report.module'
import presentationChat from './chat.module'
import yearWrapUp from './wrap-up.module'
import collaboration from './collaboration.module'
import presentationEditor from './editor.module'
import templateCategory from './template-category.module'
import presentationsModule from './presentations.module'

export default {
  presentationTemplates,
  contentSlideTemplates,
  presentationReport,
  presentationChat,
  yearWrapUp,
  collaboration,
  presentationEditor,
  templateCategory,
  presentationsModule,
}
